/**
 * AEB设备配置-批量读取结果展示表单
 */
import React, { useEffect } from 'react';
import { Form, InputNumber, Row, Col } from 'antd';
import { formSearchGutter } from '@/constants/common';

interface AebDeviceConfigReadFormProps {
  data?: any; // 读取到的数据
}

const AebDeviceConfigReadForm: React.FC<AebDeviceConfigReadFormProps> = ({ data }) => {
  const [form] = Form.useForm();

  // 当数据变化时设置表单值
  useEffect(() => {
    const resultDataStr = data?.resultData || ''
    const resultData = resultDataStr ? JSON.parse(resultDataStr) : {};
    // if (resultData) {
    form.setFieldsValue(resultData);
    // }
  }, [data, form]);

  return (
    <Form form={form} layout="vertical">
      <Row gutter={formSearchGutter}>
        <Col span={12}>
          <Form.Item
            label="AEB开关"
            name="aebSwitch"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            extra="0：自启模式 1：常开模式 2：常关模式 3：记忆模式"
          >
            <InputNumber
              disabled
              min={0}
              max={3}
              precision={0}
              style={{ width: '100%' }}
              placeholder="AEB开关状态"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="设备音量"
            name="volume"
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
          >
            <InputNumber
              disabled
              min={0}
              precision={0}
              style={{ width: '100%' }}
              placeholder="设备音量"
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default AebDeviceConfigReadForm;
